import * as Types from '../types.generated'

import { gql } from '@apollo/client'
import { ConsortiumsListItemFragmentDoc } from './ConsortiumsListItem.generated'
export const ConsortiumsListFragmentDoc = gql`
  fragment ConsortiumsList on ConsortiumConnection {
    edges {
      cursor
      node {
        ...ConsortiumsListItem
      }
    }
    pageInfo {
      hasNextPage
      startCursor
      hasPreviousPage
      endCursor
    }
  }
  ${ConsortiumsListItemFragmentDoc}
`
export type ConsortiumsListFragment = {
  __typename?: 'ConsortiumConnection'
  edges: Array<{
    __typename?: 'ConsortiumEdge'
    cursor: any
    node: {
      __typename?: 'Consortium'
      id: string
      name: string
      description: string
      slug: string
      frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
      logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
    }
  }>
  pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; startCursor?: any | null; hasPreviousPage: boolean; endCursor?: any | null }
}
